var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrikeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 157.7 40.7",
    style: {
      enableBackground: "new 0 0 157.7 40.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#08CF65;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M94,31h4.8v-7.5c0-4.5,4-4.5,6.1-4.1v-5.1c-3.3-0.3-5.3,0.6-6.2,2.4h-0.1l0-2.4H94V31z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "119,31 122.1,31 127.1,24.7 131.3,31 136.9,31 130.3,21.3 136.1,14.3 130.5,14.3 123.9,22.7  123.8,22.7 123.8,22.7 123.8,5.9 119,5.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "64.5,31 68.2,31 73.9,20.3 79.5,31 83.3,31 91.8,14.3 86.2,14.3 80.9,24.9 76,14.3 71.9,14.3 66.7,25  61.7,14.3 56,14.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 111.4,
    cy: 8.9,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 14.3,
    className: "st0",
    width: 4.8,
    height: 16.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.7,15.7c2.3,0,3.4,0.4,5.1,2.1l9,9c0.3,0.3,0.3,0.4,0.4,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2 c0,0.2-0.1,0.3-0.4,0.5l-6.1,6.1c-0.3,0.3-0.4,0.3-0.5,0.4c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0c-0.2,0-0.3-0.1-0.5-0.4L3.8,17 c-0.5-0.5-0.3-1.3,0.5-1.3H14.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40,4.7c-2.3,0-3.4,0.4-5.1,2.1l-9,9c-0.3,0.3-0.3,0.4-0.4,0.5c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1,0,0.2 c0,0.2,0.1,0.3,0.4,0.5l6.1,6.1c0.3,0.3,0.4,0.3,0.5,0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.4L51,6 c0.5-0.5,0.3-1.3-0.5-1.3H40z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M150.5,25.4L150.5,25.4c-0.6,0.9-1.8,2-3.9,2c-2.4,0-4.1-1.4-4.5-3.4h13c0-0.3,0-0.8,0-1.3 c0-4.8-3.5-8.7-8.6-8.7c-5.1,0-8.9,3.8-8.9,8.7c0,4.9,3.8,8.7,8.9,8.7c3.8,0,6.1-1.5,7.6-3.5L150.5,25.4z M146.3,17.7 c2.2,0,3.8,1.2,4.3,3H142C142.5,19,144,17.7,146.3,17.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrikeLogo);
export default __webpack_public_path__ + "static/media/Wrike_logo.4c5f53c02e67fb67fbcb3a82ed619ef4.svg";
export { ForwardRef as ReactComponent };